import { createContext } from 'react';

export const EditAreaContext = createContext(null);
